import { Stack, type SxProps } from '@mui/material';
import type { ReactNode } from 'react';

interface Props {
  children: ReactNode;
  sx?: SxProps;
  role?: string;
  title?: string;
}

export default function Pane({ children, sx, role, title }: Props) {
  return (
    <Stack
      sx={{
        backgroundColor: 'background.default',
        p: 3,
        borderRadius: '12px',
        boxShadow: `
          inset 0 1px 0 0 rgba(255,255,255,0.7),
          inset 0 -1px 0 0 rgba(0,0,0,0.03),
          0 0 0 1px rgba(0,0,0,0.04)
        `,
        ...sx,
      }}
      role={role}
      title={title}
    >
      {children}
    </Stack>
  );
}
